// Custom fetch implementation that attaches the Bearer token natively
export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    const sessionStr = localStorage.getItem('mitifresh_session');

    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(options.headers as Record<string, string> || {}),
    };

    if (sessionStr) {
        try {
            const session = JSON.parse(sessionStr);
            if (session.token) headers['Authorization'] = `Bearer ${session.token}`;
        } catch (e) {
            console.error("Failed parsing local storage session.");
        }
    }

    // Do not set Content-Type manually if the body is FormData (browser needs to set boundary)
    if (options.body instanceof FormData) {
        delete headers['Content-Type'];
    }

    return fetch(`${baseUrl}${url}`, { ...options, headers });
};
